<template>
    <section
        class="hero-banner__wrapper"
        :class="{ 'hero-banner__wrapper--error': containErrorPlaceHolder }"
    >
        <BaseLink
            v-progressive-background="{ src: imagesWithClass, handlePixelRatio: true }"
            :href="url"
            :title="`Sprawdź naszą oferte na - ${url}`"
            class="hero-banner__image-wrapper"
        >
            <ProgressiveImage
                :data="{ src: imagesWithClass.mobile, alt: `Sprawdź naszą oferte na - ${url}` }"
                class="hero-banner__image tablet-hide desktop-hide"
            />
        </BaseLink>
    </section>
</template>

<script>
import BaseLink from '~/components/common/Link/BaseLink';
import ProgressiveImage from '~/components/common/Image/ProgressiveImage';

export default {
    name: 'HeroBanner',
    components: {
        BaseLink,
        ProgressiveImage,
    },
    props: {
        url: {
            type: String,
            required: true,
        },
        images: {
            type: Array,
            required: true,
        },
    },
    data() {
        return {
            containErrorPlaceHolder: false,
        };
    },
    computed: {
        imagesWithClass() {
            return this.images.reduce((imagesObject, image) => {
                imagesObject[image.type] = image.src;
                return imagesObject;
            }, {});
        },
    },
};
</script>

<style lang="scss">
    .hero-banner {
        width: 100%;
        height: 100%;
        text-align: center;

        &__wrapper {
            width: 100%;
            position: relative;
            background: $color-slate5;
            overflow: hidden;
            text-align: center;

            &--error {
                height: 266px;
                background: $color-castoWhite;
            }
        }

        &__image {
            max-width: 100%;
            width: 100%;
        }

        &__image-wrapper {
            background-size: cover;
            background-position: center;
            background-repeat: no-repeat;
            display: inline-block;
            width: 100%;
        }
    }

    @media (min-width: $breakpoint-tablet)  {
        .hero-banner {
            &__wrapper {
                max-height: 465px;
            }

            &__image {
                max-width: 1920px;
                background-repeat: no-repeat;
            }
        }
    }

    @media (min-width: $mf-breakpoint-tablet) and (max-width: $breakpoint-small-desktop)  {
        .hero-banner__image-wrapper {
            height: 228px;
        }
    }

    @media (min-width: $mf-breakpoint-small-desktop)  {
        .hero-banner__image-wrapper {
            height: 310px;
        }
    }

    @media (min-width: $mf-breakpoint-big-desktop) {
        .hero-banner__image-wrapper {
            height: 465px;
        }
    }

    @media (min-width: $mf-breakpoint-ultra-wide) {
        .hero-banner__image-wrapper {
            background-size: unset;
        }
    }
</style>
